import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCampaignEditorLink } from 'utils/appRoutes';
import { CampaignState } from 'modules/domains/campaign';
import { WordBreakLabel } from 'modules/experiments/components/pages/index/sections/table/cells/Styled';
import { Tooltip } from 'ui/tooltip';
import { MemoSearchableText } from 'ui-beta/searchableText';
import { getChooseCampaignSearch } from 'modules/experiments/ducks/selectors';

import { BaseCellWrapper, NameLabelLink } from '../../styled';

type CampaignNameCellProps = {
  id: number;
  name: string;
  state: CampaignState;
};

export const CampaignNameCell = ({ id, name, state }: CampaignNameCellProps) => {
  const labelRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const search = useSelector(getChooseCampaignSearch);

  useEffect(() => {
    const spanElement = labelRef.current;
    if (spanElement) {
      setIsTruncated(spanElement.offsetHeight < spanElement.scrollHeight);
    }
  }, []);

  return (
    <BaseCellWrapper>
      <Tooltip isEnabled={isTruncated} tooltipContent={name}>
        <NameLabelLink href={getCampaignEditorLink(id, state)}>
          <WordBreakLabel ref={labelRef}>
            <MemoSearchableText isCaseSensitive={false} text={name} searchText={search || ''} />
          </WordBreakLabel>
        </NameLabelLink>
      </Tooltip>
    </BaseCellWrapper>
  );
};
